import React from 'react';

// Shows the released application version in the footer, e.g. "v0.2.1".
// The value is injected at build time from the Helm chart's appVersion (see package.json `build:js`),
// so it always reflects exactly what was built/deployed: the release tag in production (0.2.1) and the
// -SNAPSHOT on develop/staging. Rendered in every environment so we can confirm which build is live.
const Version = () => {
   const version = process.env.REACT_APP_UPWARD_VERSION;

   if (!version) {
      return null;
   }

   return (
      <span className='ml-2 small text-muted' title={ `Version ${ version }` }>
         v
         { version }
      </span>
   );
};

export default Version;
